<template>
	<v-dialog persistent width="auto" v-model="showDialog" v-if="selectedLab">
		<v-card style="min-height: 50vh; max-height: 80vh; width: 33vw; min-width: 400px" class="d-flex flex-column">
			<v-card-title class="card-header text-left fixed-card-title2">
				<v-row no-gutters>
					<v-col class="align-center d-flex" cols="10">
						<v-toolbar-title>{{ $t('labs-details-header') }}</v-toolbar-title>
					</v-col>
					<v-spacer></v-spacer>
					<v-icon @click="$emit('closeDialog')" class="white-icon">mdi-close</v-icon>
				</v-row>
			</v-card-title>
			<v-card-text class="pa-4 flex-grow-1 d-flex flex-column overflow-y-auto">
				<div class="flex-grow-1">
					<v-row dense class="ma-0">
						<v-col cols="6" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('test-name') }}:</div>
							<div class="text-body-1">{{ selectedLab.testName }}</div>
						</v-col>
						<v-col cols="6" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('panel-group') }}:</div>
							<div class="text-body-1">{{ selectedLab.panelGroup }}</div>
						</v-col>

						<v-col cols="6" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('value') }}:</div>
							<div class="text-body-1">{{ selectedLab.value }}</div>
						</v-col>
						<v-col cols="6" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('unit') }}:</div>
							<div class="text-body-1">{{ selectedLab.unit }}</div>
						</v-col>

						<v-col cols="6" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('specimen-type') }}:</div>
							<div class="text-body-1">{{ selectedLab.specimenType }}</div>
						</v-col>
						<v-col cols="6" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('interpretation') }}:</div>
							<div class="text-body-1">{{ selectedLab.interpretation }}</div>
						</v-col>

						<v-col cols="6" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('is-critical') }}:</div>
							<div class="text-body-1">{{ selectedLab.isCritical ? 'Yes' : 'No' }}</div>
						</v-col>
						<v-col cols="6" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('related-diagnosis-code') }}:</div>
							<div class="text-body-1">{{ selectedLab.relatedDiagnosisCode }}</div>
						</v-col>

						<v-col cols="6" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('lab-date') }}:</div>
							<div class="text-body-1">{{ formatTimestamp(selectedLab.labDate, 'date_med') }}</div>
						</v-col>
					</v-row>
				</div>
			</v-card-text>

			<!-- Original v-card-actions section preserved exactly as provided -->
			<v-card-actions>
				<v-row dense class="ma-0">
					<v-col cols="8" class="text-left">
						<span class="text-subtitle-1 font-weight-bold">{{ $t('timestamp') }}:</span>
						<span class="text-body-1">
							{{ formatTimestamp(selectedLab.reviewedAt, 'datetime_med') }}
						</span>
					</v-col>
					<v-col cols="4" class="text-right">
						<span class="text-subtitle-1 font-weight-bold">{{ $t('By') }}:</span>
						<span class="text-body-1">{{ selectedLab.reviewedBy }}</span>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { formatTimestamp } from '@/utils/utilities';
export default {
	name: 'CCMlabViewDialog',
	props: ['showDialog', 'selectedLab'],
	methods: {
		formatTimestamp,
	},
};
</script>
